import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const QUOTES = [
  {
    quote:
      "Catherine has been a trusted speaker for Paycor since 2017, consistently delivering outstanding webinars filled with actionable insights. When it comes to creating positive workplace cultures, she is our go-to expert.",
    name: "Kayla O'Neal",
    role: "Senior Webinar Producer, Paycor",
  },
  {
    quote:
      "Over my career I've seen similar presentations and honestly have never been impressed by them. Yours was excellent — research with citations, multiple viewpoints, and not limited to the US.",
    name: "Jan Price",
    role: "Manager, Professional Learning Resources, EAPA",
  },
  {
    quote:
      "I was really happy with how the training went, and have gotten nothing but positive feedback from the workshop attendees. Civility Partners did a great job — they spent a lot of time ensuring the material was pertinent to our needs, and they really got people to interact with them and with each other during the training.",
    name: "Shaney McCoy",
    role: "Weber State University",
  },
];

export const Testimonials = () => (
  <section className="border-y border-navy/10 bg-white py-24 lg:py-28" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">What people are saying</p>
        <h2 className="mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
          Testimonials from leaders who've experienced the training.
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {QUOTES.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.08}>
            <figure className="flex h-full flex-col rounded-3xl border border-slate-200 bg-cream p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-terra/50" data-testid={`testimonial-${i + 1}`}>
              <Quote className="h-7 w-7 text-terra" aria-hidden="true" />
              <blockquote className="mt-5 flex-1 leading-relaxed text-navy/80">"{q.quote}"</blockquote>
              <figcaption className="mt-6 border-t border-navy/10 pt-5">
                <p className="font-display font-bold">{q.name}</p>
                <p className="mt-1 text-sm text-navy/55">{q.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
